import { Logo } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';

const Header = (props) => {
  const { customer, step, onMenuClick, settings } = props;
  return (
    <div className="c7-checkout__header">
      <Logo />

      {renderMenu(customer, step, onMenuClick, settings)}
    </div>
  );
};

const renderMenu = (customer, step, onMenuClick, settings) => {
  const customerClick = (e) => {
    e.preventDefault();
    onMenuClick('customer');
  };
  const accountClick = (e) => {
    e.preventDefault();
    onMenuClick('account');
  };
  const paymentClick = (e) => {
    e.preventDefault();
    onMenuClick('payment');
  };
  let clubSelection = 'Club Selection';
  if (isPreSale()) {
    clubSelection = 'Pre-Sale Selection';
  }
  switch (step) {
    case 'customer': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div className="active">Customer information</div>
          <div>Payment information</div>
          {renderAccount(customer, false)}
        </div>
      );
    }
    case 'payment': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer information</a>
          </div>
          <div className="active">Payment information</div>
          {renderAccount(customer, false)}
        </div>
      );
    }
    case 'account': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer information</a>
          </div>
          <div>
            <a onClick={paymentClick}>Payment information</a>
          </div>
          {renderAccount(customer, true)}
        </div>
      );
    }
    case 'complete': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer information</a>
          </div>
          <div>
            <a onClick={paymentClick}>Payment information</a>
          </div>
          {renderAccount(customer, true, accountClick)}
        </div>
      );
    }
    default:
      throw new Error('Invalid Step');
  }
};

const renderAccount = (customer, isActive, accountClick) => {
  if (!customer) {
    if (!isActive && !accountClick) {
      return <div>Account</div>;
    }
    if (!isActive) {
      return (
        <div>
          <a onClick={accountClick}>Account</a>
        </div>
      );
    }
    return <div className="active">Account</div>;
  }
  return null;
};

export default Header;
